import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const BuatEmailService = {}

BuatEmailService.post = function (token) {
    //console.log(id_peserta_didik);
    return fetch({
        url: '/transaksi/buatemail',
        method: 'post',
        params: {
            "access_token":token,
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default BuatEmailService;
